module.exports = __webpack_public_path__ + "static/img/superior-bg-ipad-1.04eeef63.png";